import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import * as actions from 'actions';
import GetAddClientWizardStep from './GetAddClientWizardStep';
import GetBookWithClientWizardStep from './GetBookWithClientWizardStep';

class CompanyPortalWizard extends React.Component{

    getWizardStepContent = (pageNumber, type) => {
        let child;
        switch(type){
            case 'addClient':
                child = <GetAddClientWizardStep pageNumber={pageNumber}/>;
                break;
            case 'bookWithClient':
                child = <GetBookWithClientWizardStep pageNumber={pageNumber}/>;
                break;
        };
        return child;
    }

    render(){
        const { currentWizardStep, dialogType } = this.props;
        const child = this.getWizardStepContent(currentWizardStep, dialogType);
        return(
            <div>
                {child}
            </div>
        )
    }
}

const mapStateToProps = ({company}) => ({
    currentWizardStep: company.currentWizardStep,
    dialogType: company.dialogType,
});

export default connect(mapStateToProps,actions)(CompanyPortalWizard);


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CompanyPortalWizard.jsx